import { LoadingButton } from '@mui/lab';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';

/**
 * A direction means one thing, and it means it for every drug that uses it. Choosing a different
 * sig for a direction that is already approved changes what it means everywhere, so the reviewer
 * is told before it happens rather than after.
 */
const ConfirmDirectionReassignmentDialog = ({
  open,
  onClose,
  onConfirm,
  loading,
  direction,
  currentSig,
  nextSig,
}) => (
  <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
    <DialogTitle>Change what this direction means?</DialogTitle>

    <DialogContent>
      <Stack spacing={2}>
        <Stack spacing={0.5}>
          <Typography variant='caption' color='text.secondary'>
            Direction
          </Typography>
          <Typography variant='body2'>{direction}</Typography>
        </Stack>

        <Stack spacing={0.5}>
          <Typography variant='caption' color='text.secondary'>
            Currently approved as
          </Typography>
          <Typography variant='body2' sx={{ fontWeight: 600 }}>
            {currentSig}
          </Typography>
        </Stack>

        <Stack spacing={0.5}>
          <Typography variant='caption' color='text.secondary'>
            Changing to
          </Typography>
          <Typography variant='body2' sx={{ fontWeight: 600 }}>
            {nextSig}
          </Typography>
        </Stack>

        <Typography variant='body2' color='text.secondary'>
          Every drug that uses this direction will resolve to the new sig. Their next orders go to
          Direction Review until the new sig is approved for them.
        </Typography>
      </Stack>
    </DialogContent>

    <DialogActions>
      <Button variant='outlined' color='secondary' onClick={onClose}>
        Cancel
      </Button>
      <LoadingButton variant='contained' loading={loading} onClick={onConfirm}>
        Change it
      </LoadingButton>
    </DialogActions>
  </Dialog>
);

ConfirmDirectionReassignmentDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  direction: PropTypes.string,
  currentSig: PropTypes.string,
  nextSig: PropTypes.string,
};

ConfirmDirectionReassignmentDialog.defaultProps = {
  loading: false,
  direction: '',
  currentSig: '',
  nextSig: '',
};

export default ConfirmDirectionReassignmentDialog;
